import React, { useState, useEffect, useRef } from 'react';
import "survey-core/survey-core.css";
import "survey-creator-core/survey-creator-core.css";
import { SurveyCreator } from "survey-creator-react";
import { SurveyCreatorComponent } from "survey-creator-react";
import Spinner from './Spinner';

// necessary import to configure your own survey-creator theme. At the moment I only override css var in index.css and disable showCreatorThemeSettings
// import SurveyCreatorTheme from "survey-creator-core/themes";
// import { registerCreatorTheme } from "survey-creator-core";
// registerCreatorTheme(SurveyCreatorTheme);

// auth import
import { useAuth } from '../../hooks/useAuth'; // Adjust path if needed
import { useAuthenticatedApi } from '../../hooks/useAuthenticatedApi'; // Adjust path if needed


import API_CONFIG from '../../config/api'
const BASE_URL = API_CONFIG.BASE_URL;


const defaultCreatorOptions = {
	autoSaveEnabled: true,
	collapseOnDrag: true,
	showCreatorThemeSettings: false,
	showThemeTab: true
};

const defaultJson = {
		pages: [{
			name: "Name",
			elements: [{
				name: "FirstName",
				title: "Enter your first name:",
				type: "text"
			}, {
				name: "LastName",
				title: "Enter your last name:",
				type: "text"
			}]
		}]
	};

	// Official code from SurveyJS doc but trigger react error because of the setCreator(creator); re-rendering during render 
	// change the useEffect thing in case I have problem weird behaviour
	// if (!creator) {
	//   creator = new SurveyCreator(props.options || defaultCreatorOptions);
	//   setCreator(creator);
	// }

	// creator.text = JSON.stringify(props.json) || JSON.stringify(defaultJson);

function SurveyCreatorWidget(props) {
	let [creator, setCreator] = useState();
	const { isAuthenticated } = useAuth(); // Assuming useAuth provides isAuthenticated or user object
	const { authenticatedFetch } = useAuthenticatedApi();

	const authRef = useRef({ isAuthenticated, authenticatedFetch });
	useEffect(() => {
		authRef.current = { isAuthenticated, authenticatedFetch };
	}, [isAuthenticated, authenticatedFetch]);

	const saveInitialQuestions = async (creator, survey_id) => {
		const { isAuthenticated, authenticatedFetch } = authRef.current;
		
		if (!isAuthenticated || !survey_id) return;
		
		try {
			const questions = creator.survey
							.getAllQuestions()
							.map(q => Object.assign(q.toJSON(), { type: q.getType() }));
			
			const material = {
				"survey_id": survey_id,
				"survey": creator.JSON,
				"survey_all_question_array": questions
			}
			
			const result = await authenticatedFetch(BASE_URL + "/draft_surveys/update-survey/" + survey_id, {
				body: JSON.stringify(material)
			}, 'PUT');
			
			if (result.ok) {
				console.log("Initial questions saved successfully");
			}
		} catch (err) {
			console.error("Error saving initial questions:", err);
		}
	};
	

	const saveSurveyTheme = async (url, survey_json, saveNo, callback, survey_id) => {

		const { isAuthenticated, authenticatedFetch } = authRef.current;
		
		if (!isAuthenticated) { 
			console.log("THERE IS A BIG PB, THE GUY IS NOT AUTH WTF, HOW TO DEAL WITH THAT")
			console.log("YOU MUST BE AUTHENTICATED TO EDIT SURVEYS")
			return;
		}
		try {
			const material = {
				"survey_id" : survey_id,
				"survey_theme" : survey_json
			}
			const result = await authenticatedFetch(url + survey_id, { body: JSON.stringify(material) }, 'PUT');
			if (!result.ok) {
				callback(saveNo, false);
				return
			}
			const datas = await result.json()

			if (datas && (datas.message === "survey updated succesfully" || datas.message === "survey theme updated succesfully") && datas.survey_id === survey_id) {
				callback(saveNo, true)
			} else {
				// Handle cases where the API returns an unexpected structure
				callback(saveNo, false);
				console.error("API returned unexpected structure:", result);
			}
		} catch (err) {
			console.error("Error fetching survey list:", err);
			callback(saveNo, false)
		}
	}

	const saveSurveyModel = async (url, survey_json, survey_all_question, saveNo, callback, survey_id) => {

		const { isAuthenticated, authenticatedFetch } = authRef.current;
		
		if (!isAuthenticated) { 
			console.log("THERE IS A BIG PB, THE GUY IS NOT AUTH WTF, HOW TO DEAL WITH THAT")
			console.log("YOU MUST BE AUTHENTICATED TO EDIT SURVEYS")
			return;
		}
		try {
			const material = {
				"survey_id" : survey_id,
				"survey" : survey_json,
				"survey_all_question_array": survey_all_question
			}
			const result = await authenticatedFetch(url + survey_id, { body: JSON.stringify(material) }, 'PUT');
			if (!result.ok) {
				callback(saveNo, false);
				return
			}
			const datas = await result.json()

			if (datas && (datas.message === "survey updated succesfully" || datas.message === "survey theme updated succesfully") && datas.survey_id === survey_id) {
				callback(saveNo, true)
			} else {
				// Handle cases where the API returns an unexpected structure
				callback(saveNo, false);
				console.error("API returned unexpected structure:", result);
			}
		} catch (err) {
			console.error("Error fetching survey list:", err);
			callback(saveNo, false)
		}
	}
	

	useEffect(() => {
		const newCreator = new SurveyCreator(props.options || defaultCreatorOptions);
		newCreator.saveSurveyFunc = (saveNo, callback) => {
			const questions = newCreator.survey
							.getAllQuestions()
							.map(q => Object.assign(q.toJSON(), { type: q.getType() }));
			saveSurveyModel(BASE_URL + "/draft_surveys/update-survey/",
							newCreator.JSON,
							questions,
							saveNo,
							callback,
							props.survey_id
			);
		}
		newCreator.saveThemeFunc = (saveNo, callback) => {
			saveSurveyTheme(BASE_URL + "/draft_surveys/update-survey-theme/",
							newCreator.theme,
							saveNo,
							callback,
							props.survey_id
			)
		}
		newCreator.text = JSON.stringify(props.json || defaultJson);
		if (props.json_theme) {
			newCreator.theme = props.json_theme;
		}
		setCreator(newCreator);
		// TODO maybe change to a more alegant handle
		// to be sure that survey all question is saved at least one time if user is satisfied with automatically generated one 
		if (props.survey_id && props.json) {
			setTimeout(() => {
				saveInitialQuestions(newCreator, props.survey_id);
			}, 100);
		}
	}, [props.options, props.json]);

	if (!creator) {
		return (
			<div className="flex flex-col items-center justify-center min-h-screen gap-2">
				<Spinner text="Loading the editor..." size="md" className="mb-4" />
			</div>
		);
	}	
	return (
			<div style={{ height: "100vh", width: "100%" }}>
				<SurveyCreatorComponent creator={creator} />
			</div>
		);
};

export default SurveyCreatorWidget;